import { useUpdateManagementKey } from '@api/managementKeys';
import React from 'react';
import { AccessKeyType } from 'types/accessKeys';
import { IRowActionDialogProps } from 'types/common';
import { AccessKeyEditDialog } from '../../AccessKeys/index';

const EditDialog: React.FC<IRowActionDialogProps> = (props) => {
	const mutation = useUpdateManagementKey();
	return (
		<AccessKeyEditDialog
			{...props}
			mutation={mutation}
			accessKeyType={AccessKeyType.management}
		/>
	);
};

export default EditDialog;
